import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from '@bos/ui';
import { formatDateToDays } from '@bos/utils';
import { useMobilityUiConfig } from '../context/MobilityUiProvider/MobilityUiProvider';
export const MobilityDateFieldDescription = ({ firstParagraphFirstPart, firstParagraphSecondPart, firstParagraphThirdPart, secondParagraph, minDate, maxDate, }) => {
    const { Text } = useMobilityUiConfig();
    if (!firstParagraphFirstPart ||
        !firstParagraphSecondPart ||
        !firstParagraphThirdPart)
        return;
    const minDateFormatted = formatDateToDays(minDate);
    const maxDateFormatted = formatDateToDays(maxDate);
    return (_jsxs(FlexContainer, { direction: 'column', children: [_jsxs(Text, { variant: 'b2', children: [firstParagraphFirstPart, _jsx(Text, { variant: 's2', as: 'span', children: minDateFormatted }), firstParagraphSecondPart, _jsx(Text, { variant: 's2', as: 'span', children: maxDateFormatted }), firstParagraphThirdPart] }), _jsx(Text, { variant: 'b2', children: secondParagraph })] }));
};
